const CitiesCoordinates: Record<string, Array<number>> = {
    'Минск': [53.902284, 27.561831],
    'Киев': [50.450441, 30.523550]
}

export default CitiesCoordinates;